module.exports = __webpack_public_path__ + "static/img/t2.75c8d477.png";